import { render, staticRenderFns } from "./moment-manage.vue?vue&type=template&id=abfdc7b4&scoped=true"
import script from "./moment-manage.vue?vue&type=script&lang=js"
export * from "./moment-manage.vue?vue&type=script&lang=js"
import style0 from "./moment-manage.vue?vue&type=style&index=0&id=abfdc7b4&prod&lang=less&scoped=true"
import style1 from "./moment-manage.vue?vue&type=style&index=1&id=abfdc7b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfdc7b4",
  null
  
)

export default component.exports